import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableHead, TableRow, withStyles } from '@material-ui/core';
import styles from './styles';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import DefaultConfig from './config';
import Columns from './columns';
import useTableConfig from 'hooks/useTableConfig';
import { getTableKey } from 'services/util/tableConfigHelper';
import { TableKind } from 'services/enums/TableKind';
import { Portlet, PortletContent, TableCellWithConfig, TableSettings, TextPlaceholderWrapper } from 'components';
import { displayModes } from 'services/enums/displayModes';

function TemplateStopAddTable(props) {

  const {
    classes,
    className,
    t,
    templateStops,
    addOrRemoveTemplateStop,
    templateStopsToAdd,
    selectedTemplate,
    displayMode,
  } = props;

  const [sortedTemplateStops, setSortedTemplateStops] = useState([]);

  const defaultConfig = useTableConfig(DefaultConfig, displayMode, getTableKey(TableKind.TemplateStopAddTable, displayMode))

  const rootClassName = classNames(classes.root, className);

  useEffect(() => {
    const pickups = [];
    const deliveries = [];
    const others = [];
    // group template stops  
    templateStops.forEach(templateStop => {
      if (templateStop) {
        if (templateStop.pickupDeliveryPickup?.length > 0) {
          pickups.push(templateStop);
        } else if (templateStop.pickupDeliveryDelivery?.length > 0) {
          deliveries.push(templateStop);
        } else {
          others.push(templateStop);
        }
      }
    });
    // sort pickup and delivery template stops  
    const sortedTemplateStopList = [];
    pickups.forEach(pickup => {
      sortedTemplateStopList.push(pickup);
      const relatedDeliveries = deliveries.filter(delivery =>
        delivery.pickupDeliveryDelivery.some(deliveryItem =>
          deliveryItem.pickupStopId === pickup.id));
      sortedTemplateStopList.push(...relatedDeliveries);
    });
    // find deliveries that aren't in the sortedTemplateStopList
    const remainingDeliveries = deliveries.filter(delivery =>
      !sortedTemplateStopList.some(sortedTemplateStop => sortedTemplateStop.id === delivery.id)
    );
    sortedTemplateStopList.push(...remainingDeliveries);
    // add template stops without templateStop  
    sortedTemplateStopList.push(...others);
    setSortedTemplateStops(sortedTemplateStopList);
  }, [templateStops]);

  return (
    <TextPlaceholderWrapper
      active={!templateStops?.length}
      text={t('noCustomersAvailable')}
    >
      <div style={{ position: 'relative' }}>
        <TableSettings
          updateConfig={defaultConfig.updateConfig}
          tableConfig={defaultConfig.config}
          columns={Columns}
          buttonOptic
        />
        <Portlet className={rootClassName}>
          <PortletContent noPadding>
            <Table
              size={'small'}
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {defaultConfig.columnConfigs.map(columnConfig => (
                    <TableCellWithConfig
                      key={columnConfig.order}
                      config={columnConfig}
                    >
                      {Columns[columnConfig.columnName].header({ t })}
                    </TableCellWithConfig>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedTemplate && sortedTemplateStops.map((templateStop, index) => {
                  return (
                    <TableRow
                      className={classNames(classes.tableRow, 'cursorPointer')}
                      hover
                      key={index}
                      onClick={() => addOrRemoveTemplateStop(templateStop)}
                      selected={templateStopsToAdd.some(c => c.id === templateStop.id)}
                    >
                      {defaultConfig.columnConfigs.map(columnConfig => (
                        <TableCellWithConfig
                          key={columnConfig.order}
                          config={columnConfig}
                        >
                          {Columns[columnConfig.columnName].body({ templateStop, t })}
                        </TableCellWithConfig>
                      ))}
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </PortletContent>
        </Portlet>
      </div>
    </TextPlaceholderWrapper>
  );
}

TemplateStopAddTable.propTypes = {
  addOrRemoveTemplateStop: PropTypes.func.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  templateStops: PropTypes.array.isRequired,
  templateStopsToAdd: PropTypes.array.isRequired,
  displayMode: PropTypes.oneOf(Object.values(displayModes)).isRequired,
  selectedTemplate: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(withStyles(styles), withTranslation())(TemplateStopAddTable);
